// Dados mock de backup para a Dashboard
// Usado quando a API falha ou fica offline

export const mockStats = {
  total_leads: 156,
  contratos_assinados: 42,
  concluidos: 38,
  novos: 15,
  dados_coletados: 28,
  pagos: 45
};

export const mockRecentLeads = [
  {
    id: 1,
    nome: 'João Silva',
    cpf_cnpj: '123.456.789-00',
    telefone: '(62) 99876-5432',
    status: 'novo',
    data_criacao: '2026-06-02T10:30:00.000Z'
  },
  {
    id: 2,
    nome: 'Maria Santos',
    cpf_cnpj: '987.654.321-00',
    telefone: '(62) 99123-4567',
    status: 'dados_coletados',
    data_criacao: '2026-06-02T09:15:00.000Z'
  },
  {
    id: 3,
    nome: 'Pedro Oliveira',
    cpf_cnpj: '456.789.123-00',
    telefone: '(62) 99765-4321',
    status: 'pago',
    data_criacao: '2026-06-01T16:45:00.000Z'
  },
  {
    id: 4,
    nome: 'Ana Costa',
    cpf_cnpj: '321.654.987-00',
    telefone: '(62) 99234-5678',
    status: 'contrato_assinado',
    data_criacao: '2026-06-01T14:20:00.000Z'
  },
  {
    id: 5,
    nome: 'Carlos Lima',
    cpf_cnpj: '789.123.456-00',
    telefone: '(62) 99890-1234',
    status: 'concluido',
    data_criacao: '2026-06-01T11:00:00.000Z'
  }
];

export const mockConversionRate = {
  total: 156,
  convertidos: 80,
  taxa_conversao: 51.28
};

export const mockRevenue = {
  period: 30,
  total_receita: 15450.00,
  por_dia: [
    { data: '2026-06-02', receita: 1250.00 },
    { data: '2026-06-01', receita: 2100.00 },
    { data: '2026-05-31', receita: 980.00 },
    { data: '2026-05-30', receita: 1750.00 },
    { data: '2026-05-29', receita: 890.00 },
    { data: '2026-05-28', receita: 1560.00 },
    { data: '2026-05-27', receita: 2100.00 },
    { data: '2026-05-26', receita: 1340.00 },
    { data: '2026-05-25', receita: 920.00 },
    { data: '2026-05-24', receita: 2560.00 }
  ]
};

export const getMockData = () => ({
  stats: mockStats,
  recentLeads: mockRecentLeads,
  conversionRate: mockConversionRate,
  revenue: mockRevenue
});
